import React from 'react';
import { func, object } from 'prop-types';

import CSS from './styles.scss';
import FilterHighlightOptions from './FilterHighlightOptions';
import { X } from 'Shared/Icons';


const FilterPanelViews = ({ handleClick, isFilterPanelOpen }) => {
  let styles = {};

  if (isFilterPanelOpen) {
    styles = { 'right': '0px' };
  }

  return (
    <div className={ `${CSS['container']}`} style={ styles }>
      <header className={ CSS['header'] }>
        <span className={ CSS['text'] }>Filter your results</span>
        <X className={ CSS['icon-x'] }
          handleClick={ handleClick }
          width="18"
          height="18"
          fill="#989898" />
      </header>
      <div className={ CSS['body'] }>
        <FilterHighlightOptions />
      </div>
    </div>
  );
};

FilterPanelViews.propTypes = {
  handleClick: func,
  rightSidePanel: object
};


export default FilterPanelViews;
